import React, { useEffect } from 'react';

const AdComponent = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
          window._taboola = window._taboola || [];
          _taboola.push({
            mode: 'alternating-thumbnails-a',
            container: 'taboola-below-article-thumbnails',
            placement: 'Below Article Thumbnails',
            target_type: 'mix',
            'article': 'auto',
            'count': 3, // No more than 3 ads
            'row': 1     // Only one row
          });
        `;
        document.body.appendChild(script);
    }, []);

    return <div id="taboola-below-article-thumbnails"></div>;
};

export default AdComponent;
